import React__default, { useContext, useEffect } from 'react';
import Styles from './ServiceTypeForm.module.scss.js';
import { AppContext } from '../../../app-context.js';
import { LoginFormModel } from '../../auth/login-form-model.js';
import ServiceTypeSelection from '../../auth/service-type-selection/ServiceTypeSelection.js';
import { serviceTypeModel } from './serviceTypeModel.js';
import classNames from 'classnames';

const ServiceTypeForm = ({ formikConfig, className }) => {
    const { serviceType, phoneNum } = useContext(AppContext);
    useEffect(() => {
        if (serviceType) {
            formikConfig === null || formikConfig === void 0 ? void 0 : formikConfig.setFieldValue(LoginFormModel.serviceType.fields.serviceType, serviceType);
        }
        else {
            formikConfig.setFieldError(LoginFormModel.serviceType.fields.serviceType, "Required!");
        }
    }, []);
    const customHandleChange = (e) => {
        formikConfig.handleChange(serviceTypeModel.fields.serviceType)(e);
    };
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement("h3", { className: Styles.serviceTypeTitle }, "What Do You Do?"),
            React__default.createElement(ServiceTypeSelection, { className: Styles.serviceType, handleChange: customHandleChange, serviceTypeModal: true }))));
};

export { ServiceTypeForm as default };
//# sourceMappingURL=ServiceTypeForm.js.map
